var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDs2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 588.7 588.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3,.cls-5,.cls-6,.cls-7{mix-blend-mode:lighten;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{mix-blend-mode:screen;}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:#fff;}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:#404041;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.53,
    y1: 294.35,
    x2: 587.17,
    y2: 294.35,
    gradientTransform: "translate(456.19 -89.17) rotate(67.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b0e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#02afe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#09ade1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#14aad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#25a5ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3b9ebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5796ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#768d97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#83898e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9d8377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b87e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ce794b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#df753b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ea7331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f1712b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 294.35,
    x2: 588.7,
    y2: 294.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#02c0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#09beec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#14bce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#25b9d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3bb5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#57b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#77aa97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#9ba47b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#b49f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c09a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d39145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e28a34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ec8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f28322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f48220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 455.57,
    y1: 455.57,
    x2: -245.76,
    y2: -245.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6921e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 453.53,
    y1: 455.57,
    x2: -247.8,
    y2: -245.76,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 376.52,
    y1: 356.74,
    x2: 211.85,
    y2: 140.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05a28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 302.8,
    y1: 392.12,
    x2: 137.02,
    y2: 174.29,
    xlinkHref: "#linear-gradient-5"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Datassential") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.99,
    y: 65.99,
    width: 456.72,
    height: 456.72,
    rx: 15.55,
    ry: 15.55,
    transform: "translate(-89.17 456.19) rotate(-67.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M579.2,422,187.07,587.48a15.6,15.6,0,0,1-20.37-8.28L1.22,187.07A15.6,15.6,0,0,1,9.5,166.7L401.63,1.22A15.6,15.6,0,0,1,422,9.5L587.48,401.63A15.6,15.6,0,0,1,579.2,422Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.35,536.73,52,305.34a15.6,15.6,0,0,1,0-22L283.35,52a15.6,15.6,0,0,1,22,0L536.73,283.35a15.6,15.6,0,0,1,0,22L305.34,536.73A15.6,15.6,0,0,1,283.35,536.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M281.31,536.73,49.93,305.34a15.6,15.6,0,0,1,0-22L281.31,52a15.6,15.6,0,0,1,22,0L534.69,283.35a15.6,15.6,0,0,1,0,22L303.3,536.73A15.6,15.6,0,0,1,281.31,536.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M282.31,536.73,50.93,305.34a15.6,15.6,0,0,1,0-22L282.31,52a15.6,15.6,0,0,1,22,0L535.69,283.35a15.6,15.6,0,0,1,0,22L304.3,536.73A15.6,15.6,0,0,1,282.31,536.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M376.82,259.44l-1.64-5.64c-.69-2.38-1.31-4.32-1.94-6.1-4.72-13.3-11.45-24.62-20-33.64a85.41,85.41,0,0,0-30.71-20.67,107.81,107.81,0,0,0-40-7.2H210.66v73.26H185.31V162.59h97.2c18.07,0,34.88,3,50,9a111,111,0,0,1,39.42,26.26c10.93,11.37,19.51,25.39,25.5,41.68,1.17,3.18,2.25,6.52,3.21,9.94l2.79,9.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.31,426.1V334.46h25.35v68.06h71.85a107.77,107.77,0,0,0,40-7.2,85.33,85.33,0,0,0,30.7-20.67c8.55-9,15.27-20.34,20-33.64l.4-1.24,1.81-5.31h26.82l-3.35,10.26c-.49,1.49-1,3-1.52,4.42-6,16.3-14.58,30.32-25.5,41.69a111,111,0,0,1-39.42,26.27c-15.08,6-31.89,9-50,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M164.78,295a20.91,20.91,0,0,1-1.23,7.38,15.9,15.9,0,0,1-3.45,5.58,15,15,0,0,1-5.34,3.53,18.58,18.58,0,0,1-6.87,1.23H135V277.3h12.93a18.59,18.59,0,0,1,6.87,1.23,14.94,14.94,0,0,1,5.34,3.53,15.92,15.92,0,0,1,3.45,5.58A20.86,20.86,0,0,1,164.78,295Zm-2.65,0a19.75,19.75,0,0,0-1-6.6,13.8,13.8,0,0,0-2.9-4.9,12.39,12.39,0,0,0-4.5-3.05,15.47,15.47,0,0,0-5.8-1.05H137.54v31.24h10.36a15.47,15.47,0,0,0,5.8-1,12.42,12.42,0,0,0,4.5-3.05,13.8,13.8,0,0,0,2.9-4.9A19.83,19.83,0,0,0,162.13,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M198.1,312.7h-2a.86.86,0,0,1-.58-.19,1.27,1.27,0,0,1-.35-.49L191,301.74H173.66L169.51,312a1.09,1.09,0,0,1-.35.47.93.93,0,0,1-.6.2h-2l14.48-35.39h2.52Zm-7.83-12.86L183.07,282a17.65,17.65,0,0,1-.73-2.1q-.15.6-.33,1.14a9.87,9.87,0,0,1-.37,1l-7.2,17.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.49,279.48H210.06V312.7h-2.58V279.48H195V277.3h27.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M250.88,312.7h-2a.86.86,0,0,1-.58-.19A1.27,1.27,0,0,1,248,312l-4.15-10.28H226.44L222.29,312a1.09,1.09,0,0,1-.35.47.93.93,0,0,1-.6.2h-2l14.48-35.39h2.52ZM243,299.84,235.85,282a17.63,17.63,0,0,1-.73-2.1q-.15.6-.33,1.14a9.89,9.89,0,0,1-.37,1l-7.2,17.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M273.44,282.45a1.84,1.84,0,0,1-.49.56,1.06,1.06,0,0,1-.64.19,1.78,1.78,0,0,1-1-.43q-.58-.42-1.44-.94a11.64,11.64,0,0,0-2.08-.94,9,9,0,0,0-2.94-.43,8.59,8.59,0,0,0-2.86.44,6.14,6.14,0,0,0-2.08,1.19,4.89,4.89,0,0,0-1.26,1.76,5.61,5.61,0,0,0-.42,2.19,4,4,0,0,0,.74,2.49,6.35,6.35,0,0,0,2,1.69,14.93,14.93,0,0,0,2.75,1.21l3.15,1.06q1.61.55,3.15,1.24a11.08,11.08,0,0,1,2.75,1.74,7.91,7.91,0,0,1,2,2.58,8.59,8.59,0,0,1,.74,3.75,12.1,12.1,0,0,1-.8,4.41,10.21,10.21,0,0,1-2.34,3.59,10.89,10.89,0,0,1-3.78,2.4,13.88,13.88,0,0,1-5.09.88,15.53,15.53,0,0,1-6.35-1.26,14.91,14.91,0,0,1-4.88-3.42l1.4-2.3a1.88,1.88,0,0,1,.49-.46,1.15,1.15,0,0,1,.64-.19,1.43,1.43,0,0,1,.74.26q.41.26.94.66c.35.27.75.56,1.2.88a9.82,9.82,0,0,0,1.54.88,10.51,10.51,0,0,0,2,.66,10.75,10.75,0,0,0,2.48.26,9.23,9.23,0,0,0,3.08-.48,6.52,6.52,0,0,0,2.29-1.34,5.79,5.79,0,0,0,1.44-2.06,6.9,6.9,0,0,0,.5-2.67,4.5,4.5,0,0,0-.74-2.67,6.14,6.14,0,0,0-1.94-1.74,13.38,13.38,0,0,0-2.75-1.19l-3.15-1a33.53,33.53,0,0,1-3.15-1.19,10.18,10.18,0,0,1-2.75-1.75,8,8,0,0,1-1.94-2.69,10.3,10.3,0,0,1,0-7.67,9.39,9.39,0,0,1,2.15-3.15,10.54,10.54,0,0,1,3.48-2.2,12.72,12.72,0,0,1,4.74-.82,15.09,15.09,0,0,1,5.47,1,12.94,12.94,0,0,1,4.34,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M299.58,282.45a1.87,1.87,0,0,1-.49.56,1.07,1.07,0,0,1-.64.19,1.77,1.77,0,0,1-1-.43c-.39-.28-.86-.6-1.44-.94a11.69,11.69,0,0,0-2.07-.94,9,9,0,0,0-2.94-.43,8.61,8.61,0,0,0-2.87.44,6.11,6.11,0,0,0-2.07,1.19,4.84,4.84,0,0,0-1.26,1.76,5.57,5.57,0,0,0-.43,2.19,4,4,0,0,0,.74,2.49,6.35,6.35,0,0,0,2,1.69,14.79,14.79,0,0,0,2.75,1.21l3.15,1.06q1.61.55,3.15,1.24a11.08,11.08,0,0,1,2.75,1.74,7.93,7.93,0,0,1,1.95,2.58,8.59,8.59,0,0,1,.74,3.75,12.1,12.1,0,0,1-.8,4.41,10.18,10.18,0,0,1-2.34,3.59,10.89,10.89,0,0,1-3.78,2.4,13.88,13.88,0,0,1-5.09.88,15.51,15.51,0,0,1-6.35-1.26,14.88,14.88,0,0,1-4.88-3.42l1.4-2.3a1.84,1.84,0,0,1,.49-.46,1.15,1.15,0,0,1,.64-.19,1.42,1.42,0,0,1,.74.26q.41.26.94.66c.35.27.75.56,1.2.88a9.85,9.85,0,0,0,1.54.88,10.49,10.49,0,0,0,2,.66,10.77,10.77,0,0,0,2.48.26,9.22,9.22,0,0,0,3.08-.48,6.52,6.52,0,0,0,2.29-1.34,5.76,5.76,0,0,0,1.44-2.06,6.86,6.86,0,0,0,.5-2.67,4.5,4.5,0,0,0-.74-2.67,6.17,6.17,0,0,0-1.94-1.74,13.37,13.37,0,0,0-2.75-1.19l-3.15-1a33.58,33.58,0,0,1-3.15-1.19,10.17,10.17,0,0,1-2.75-1.75,8,8,0,0,1-1.94-2.69,10.33,10.33,0,0,1,0-7.67,9.4,9.4,0,0,1,2.15-3.15,10.52,10.52,0,0,1,3.48-2.2,12.71,12.71,0,0,1,4.74-.82,15.1,15.1,0,0,1,5.47,1,12.9,12.9,0,0,1,4.34,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M329.5,308.74l0,4H307.39V276.85h22.09v4H312.24v11.91h14v3.8h-14v12.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M364.32,276.85V312.7h-2.43a2.07,2.07,0,0,1-1-.2,2.38,2.38,0,0,1-.76-.67l-20.74-27c0,.42.06.83.07,1.23s0,.78,0,1.13V312.7h-4.25V276.85h2.5a3.55,3.55,0,0,1,.55,0,1.49,1.49,0,0,1,.4.13,1.58,1.58,0,0,1,.35.25,3.82,3.82,0,0,1,.37.41l20.74,27q0-.65-.09-1.26c0-.41,0-.8,0-1.16V276.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M396.71,280.93H385.11V312.7h-4.83V280.93H368.65v-4.08h28.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M405.87,312.7H401V276.85h4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M443.16,312.7h-3.75a1.62,1.62,0,0,1-1.05-.32,2,2,0,0,1-.6-.83l-3.35-8.65H418.33L415,311.54a1.78,1.78,0,0,1-.58.8,1.6,1.6,0,0,1-1.05.35h-3.75l14.33-35.85h4.9Zm-10.1-13.31-5.63-14.58c-.17-.43-.34-.94-.52-1.51s-.36-1.19-.52-1.84a27.51,27.51,0,0,1-1.08,3.38l-5.63,14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M467.23,308.62v4.08H446.89V276.85h4.83v31.77Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDs2);
export default __webpack_public_path__ + "static/media/logo_ds2.449c852414265e0d0b4f9a04d226ed60.svg";
export { ForwardRef as ReactComponent };